/* eslint-disable no-underscore-dangle */
import { filterNotEmpty } from '@application/utils';
import type { ProGetProQuery } from '@gql/graphql';
import { WorkerServicePriceType } from '@gql/graphql';
import { useMemo } from 'react';
import { groupBy } from 'lodash/fp';
import type { ProPageServiceItem, ProPageServicesSection } from '@presentation/pages';

type Pro = NonNullable<ProGetProQuery['searchProfessionals']>['professionals'][number];

export const useFormatServiceSections = (pro: Pro | undefined) => {
  const serviceSections = useMemo((): ProPageServicesSection | undefined => {
    const groupedProServices = groupBy((s) => s?.category.id, pro?.services || []);
    const services = Object.values(groupedProServices)
      .filter(filterNotEmpty)
      .map((proServices) => {
        if (!proServices || !proServices?.length) return;
        return {
          title: proServices?.[0]?.category.translations[0]?.title,
          items: proServices.filter(filterNotEmpty).map((service) => {
            let price;
            if (service.priceType === WorkerServicePriceType.HOURLY && service.price) {
              price = `${service.price} €/h`;
            } else if (service.priceType === WorkerServicePriceType.FIXED && service.price) {
              price = `${service.price} €`;
            } else if (
              service.priceType === WorkerServicePriceType.RANGE &&
              service.priceTo &&
              service.priceFrom
            ) {
              price = `${service.priceFrom}€ - ${service.priceTo}€`;
            }
            let duration;
            if (
              service.fromDurationMinute &&
              service.toDurationMinute &&
              service.fromDurationMinute !== service.toDurationMinute
            ) {
              duration = `${service.fromDurationMinute} - ${service.toDurationMinute}min`;
            } else if (service.fromDurationMinute) {
              duration = `${service.fromDurationMinute}min`;
            }
            return {
              name: service.service.translations[0]?.title || '',
              duration,
              price,
              isSpecialist: service.workerServices.find((x) => x.isProSpecialist) != null,
            } as ProPageServiceItem;
          }),
        } as ProPageServicesSection[0];
      })
      .filter(filterNotEmpty);
    if (!Object.keys(services).length) return;
    return services;
  }, [pro?.services]);

  return {
    serviceSections,
  };
};
